import React from 'react';
import './DbtInvoiceSkeleton.scss';

const DbtInvoiceSkeleton = () => {
    return (
        <div className="dbt-invoice-skeleton">
            {/* Header Section */}
            <div className="skeleton-header-section">
                <div className="skeleton-title"></div>
                <div className="skeleton-subtitle"></div>
            </div>

            {/* Filters Section */}
            <div className="skeleton-filters-section">
                {/* APS Type Buttons */}
                <div className="skeleton-type-buttons">
                    <div className="skeleton-type-btn"></div>
                    <div className="skeleton-type-btn"></div>
                    <div className="skeleton-type-btn"></div>
                </div>

                {/* Filter Row */}
                <div className="skeleton-filters-row">
                    {/* Search Combo */}
                    <div className="skeleton-search-combo">
                        <div className="skeleton-label"></div>
                        <div className="skeleton-combo-wrapper">
                            <div className="skeleton-dropdown"></div>
                            <div className="skeleton-input"></div>
                        </div>
                    </div>

                    {/* From Date */}
                    <div className="skeleton-date-field">
                        <div className="skeleton-label"></div>
                        <div className="skeleton-date-input"></div>
                    </div>

                    {/* To Date */}
                    <div className="skeleton-date-field">
                        <div className="skeleton-label"></div>
                        <div className="skeleton-date-input"></div>
                    </div>

                    {/* Buttons */}
                    <div className="skeleton-filter-buttons">
                        <div className="skeleton-label invisible"></div>
                        <div className="skeleton-button-group">
                            <div className="skeleton-search-btn"></div>
                            <div className="skeleton-clear-btn"></div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Table Section */}
            {/* <div className="skeleton-table-section">
                <div className="skeleton-table">
                    <div className="skeleton-table-header">
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((col) => (
                            <div key={col} className="skeleton-th"></div>
                        ))}
                    </div>
                    <div className="skeleton-table-body">
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((row) => (
                            <div key={row} className="skeleton-table-row">
                                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((col) => (
                                    <div key={col} className={`skeleton-td ${col === 10 ? 'skeleton-badge' : ''}`}></div>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
            </div> */}

            {/* Pagination Section */}
            {/* <div className="skeleton-pagination-section">
                <div className="skeleton-results-text"></div>
                <div className="skeleton-pagination">
                    <div className="skeleton-page-button wide"></div>
                    <div className="skeleton-page-button"></div>
                    <div className="skeleton-page-button"></div>
                    <div className="skeleton-page-button"></div>
                    <div className="skeleton-page-button wide"></div>
                </div>
            </div> */}
        </div>
    );
};

export default DbtInvoiceSkeleton;
